import { FC, useState } from "react";
import styles from "../../assets/css/preview.module.scss";
import { ConnectionSessionErrorId, useApp } from "../../context/AppContext";
import { Link } from "react-router-dom";
import { trackUnavailableSizeEmailSubmitted } from "../../services/klaviyo";
import { isEmailValid } from "../../helpers/validations";
import { INVALID_EMAIL_ERROR } from "../../constants/errors";
import { isFootSizeTooSmall, isFootSizeTooLarge } from "../../helpers/foot";

const UnavailableSizeNotice: FC = () => {
  const { customInsoleValues: { leftFootLengthInMM, rightFootLengthInMM }, connectionSessionError } = useApp();

  const [email, setEmail] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const isFootSizeInvalid = connectionSessionError?.id === ConnectionSessionErrorId.FOOT_LENGTH_OUT_OF_RANGE;
  const isAnyFootSizeTooSmall = isFootSizeTooSmall(leftFootLengthInMM) || isFootSizeTooSmall(rightFootLengthInMM);
  const isAnyFootSizeTooLarge = isFootSizeTooLarge(leftFootLengthInMM) || isFootSizeTooLarge(rightFootLengthInMM);

  const renderCatalog = () => {
    if(isFootSizeInvalid) {
      return null;
    }
    let catalogLink = 'https://www.superfeet.com/collections/all-insoles?view=products';
    if(isAnyFootSizeTooSmall) {
      catalogLink += '&pfilter.mfield_cql_women_sizes=4.5 - 6';
    } else if(isAnyFootSizeTooLarge) {
      catalogLink += '&pfilter.mfield_cql_men_sizes=15.5 - 17';
    }

    return (
      <>
        <div>
          <Link to={catalogLink} target="_blank">
            Shop insoles available in your size
          </Link>
        </div>
        <div>or</div>
      </>
    );
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if(isSubmitted) {
      return;
    }
    if(!isEmailValid(email)) {
      setEmailError(INVALID_EMAIL_ERROR);
      return;
    }
    trackUnavailableSizeEmailSubmitted({ email, leftFootLength: leftFootLengthInMM.toFixed(2), rightFootLength: rightFootLengthInMM.toFixed(2) });
    setEmail('');
    setIsSubmitted(true);
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setEmailError('');
  }

  return (
    <div className={styles.UnavailableSizeNoticeContainer}>
      <div className={styles.UnavailableSizeNoticeWrapper}>
        <h1 className={styles.UnavailableSizeNoticeTitle}>We&apos;re Sorry!</h1>
        <div className={styles.UnavailableSizeNoticeText1}>
          ME3D not currently offered in your size.
          <br />
          It is available in sizes M5-15 / W6-16.
        </div>
        <div className={styles.UnavailableSizeNoticeText2}>
          {renderCatalog()}
          <div className={styles.primaryFontBlack}>Get notified when your size is available</div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.UnavailableSizeNoticeEmailContainer}>
            <input type="email" placeholder="Enter your email" className={styles.formControl} value={email} onChange={handleEmailChange} />
            {emailError && <div className={styles.errorMsg}>{emailError}</div>}
          </div>
          <div className={styles.UnavailableSizeNoticeSubmitContainer}>
            <button type="submit" className={`${styles.btnPill} ${styles.btnSecondary}`} disabled={!email || isSubmitted}>{isSubmitted ? 'Submitted' : 'Submit'}</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default UnavailableSizeNotice;
